module.exports = __webpack_public_path__ + "img/lighthouse.b54c7569.jpeg";